import { GetManyQueryDto } from '../../../classes/common/request/get-many-query.dto';
import { PartialType } from '../../../utils';
export class GetManyFeeGradesQueryDto extends PartialType(GetManyQueryDto) {
}
